// src/App.js
import React from 'react';
import useMeta from '../../hooks/useMeta';

import Navbar from '../../CommonComponent/Navbar/Navbar'; // Importing the Navbar component
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';


//page component

import NewsContent from './PageComponent/NewsContent'

function News() {

    useMeta({
        title: 'News | Callistus Blinds',
        description: 'Discover premium window treatments at Callistus Blinds. Explore our extensive range of stylish blinds and shades to enhance your home’s aesthetic and comfort.',
        canonical: 'https://callistusblinds.com/news/',
        og: {
            locale: 'en_US',
            type: 'article',
            title: 'News | Callistus Blinds',
            description:
                'Discover premium window treatments at Callistus Blinds. Explore our extensive range of stylish blinds and shades to enhance your home’s aesthetic and comfort.',
            url: 'https://callistusblinds.com/news/',
            site_name: 'Callistus Blinds',
        },
    });

    return (
        <div>
            <Navbar />
            <NotificationBar />
            <NewsContent />
            <Footer />
        </div>
    );
}

export default News;
